import type { RequestInput, FeedbackInput } from './validate'

const API_BASE = import.meta.env.VITE_API_BASE ?? ''

export interface ApiSuccess {
  ok: true
  issueNumber: number
  url: string
}

export interface ApiError {
  ok: false
  error: string
  status: number
  details?: unknown
}

export type ApiResult = ApiSuccess | ApiError

export function submitRequest(payload: RequestInput): Promise<ApiResult> {
  return submit('/api/request', payload)
}

export function submitFeedback(payload: FeedbackInput): Promise<ApiResult> {
  return submit('/api/feedback', payload)
}

async function submit(path: string, body: unknown): Promise<ApiResult> {
  let res: Response
  try {
    res = await fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
  } catch {
    return { ok: false, error: 'network', status: 0 }
  }

  let data: Record<string, unknown> = {}
  try {
    data = (await res.json()) as Record<string, unknown>
  } catch {
    // Empty / non-JSON body — keep defaults.
  }

  if (!res.ok) {
    return {
      ok: false,
      error: typeof data.error === 'string' ? data.error : `http_${res.status}`,
      status: res.status,
      details: data,
    }
  }

  return {
    ok: true,
    issueNumber: Number(data.issueNumber ?? 0),
    url: typeof data.url === 'string' ? data.url : '',
  }
}
